<template>
  <div class="bounceData">
    <!-- 数字 翻牌器-->
    <div class="displayBox">
      <div class="contentBox">
        <span>{{ currentNumber }}</span>
        <!-- <span>今日销售额(万元)</span> -->
        <span>今日销售额</span>
      </div>
      <div class="contentBox">
        <span>{{ currentNumber1 }}</span>
        <span>入驻供应商</span>
      </div>
      <div class="contentBox">
        <span>{{ currentNumber2 }}</span>
        <span>入驻采购商</span>
      </div>
      <div class="contentBox">
        <span>{{ currentNumber3 }}</span>
        <span>平台累计交易额</span>
      </div>
      <div class="contentBox">
        <span>{{ currentNumber4 }}</span>
        <span>平台融资额</span>
      </div>
      <div v-if="isShowInput" class="input-div" >
        <el-input v-model="input" class="inputCon" placeholder="搜索"/>
        <el-icon>
          <Search/>
        </el-icon>
      </div>

    </div>
    <!-- 输入框 -->
  </div>

</template>


<script>
import {Search} from '@element-plus/icons-vue'

export default {
  data() {
    return {
      currentNumber: 361800,
      currentNumber1: 134,
      currentNumber2: 469,
      currentNumber3: 1514546231,
      currentNumber4: 5652369,
      input: '',
      isShowInput: false,
      width: window.innerWidth,
    };
  },
  methods: {
    increment() {
      setInterval(() => {
        let min = Math.ceil(1); // 向上取整
        let max = Math.floor(100); // 向下取整

        this.currentNumber += Math.floor(Math.random() * (max - min + 1)) + min// 加 1 以包含 max 在内
        this.currentNumber3 += Math.floor(Math.random() * (max - min + 1)) + min;
        this.currentNumber4 += Math.floor(Math.random() * (max - min + 1)) + min;
      }, 2000);
    },

    getWidth() {
      this.width = window.innerWidth
      if (this.width < 599) {
        this.isShowInput = false
      } else {
        this.isShowInput = true
      }
    }
  },
  mounted() {
    // this.increment()
    this.getWidth()
    window.addEventListener('resize', this.getWidth); // 添加事件监听器
  },
  created() {
    this.getWidth()
  }
}

</script>


<style lang="less" scoped>
::v-deep .el-input__wrapper {
  background-color: rgb(188, 229, 208, 0.3);
  border-radius: 3px 0 0 3px;
}

::v-deep .el-icon {
  background-color: rgb(255, 255, 255);
  color: #00A54F;
  height: 40px;
  width: 40px;
  border-radius: 0 3px 3px 0;
  font-size: 23px;
}

.bounceData {
  width: 100%;
  height: 162px;
  background: rgba(0, 165, 79, 1);
  color: #fff;
}

.inputCon {
  width: 25vw;
  height: 40px;
}

.displayBox {
  display: flex;
  align-items: center;
  height: 100%;
  text-align: center;

  .input-div {
    display: flex;
    align-items: center;
    height: 100%;
    text-align: center;
  }
}

.contentBox {
  display: flex;
  justify-content: space-around; //  设置一行的排列
  flex-flow: column; // 设置主轴为x轴
  width: 14%;
  height: 100%;

  span {
    font-size: 1.4vw;
  }
}


@media screen and (max-width: 599px) {
  ::v-deep .el-input__wrapper {
    background-color: rgb(188, 229, 208, 0.3);
    border-radius: 3px 0 0 3px;
  }

  ::v-deep .el-icon {
    background-color: rgb(255, 255, 255);
    color: #00A54F;
    height: 30px;
    width: 30px;
    border-radius: 0 3px 3px 0;
    font-size: 23px;
  }

  .bounceData {
    width: 100%;
    height: 50px;
    background: rgba(0, 165, 79, 1);
    color: #fff;
  }

  .inputCon {
    width: 70px;
    height: 30px;
  }

  .displayBox {
    display: flex;
    align-items: center;
    height: 100%;
    text-align: center;
  }

  .contentBox {
    display: flex;
    justify-content: space-around;
    flex-flow: column;
    width: 100%;
    height: 100%;
    span {
      font-size: 11px;
    }
  }
}
</style>